import React from 'react';
import styles from './LoginStyles.module.scss';
import LoginModalTitle from './LoginModalTitle';

const LoginModal = (props) => {
  return <div className={styles.loginModal}>{props.children}</div>;
};

export default LoginModal;
